<div class="row">
  <div class="col-md-8">
    <h4 class="font-weight-bold">&nbsp;&nbsp;To Be Billed Customer Transaction #{{tranReservationId}}</h4>
  </div>
  <div class="col-md-4 text-right">
    <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button"
      (click)="onBack()">Back</button>

    <button (click)="getTransactionByID()" tooltip="Refresh"
      class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2" type="button">
      <span class="btn-wrapper--icon">
        <i class="ion-md-sync"></i>
      </span>
    </button>
  </div>
</div>

<div class="card card-box mb-2">
  <div class="no-gutters row">
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 p-4">
      <div class="divider-v divider-v-lg"></div>
      <div class="row">
        <div class="col">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <div class="text-black-50" style="font-size: 0.8rem;">Res Type</div>
              <span style="font-weight: 500;">{{paymentTransData[0]?.RES_TYPE}}</span>

            </div>
          </div>
          <div class="divider my-3"></div>
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <div class="text-black-50" style="font-size: 0.8rem;">Station</div>
              <span style="font-weight: 500;">{{paymentTransData[0]?.STATION}}</span>
            </div>
          </div>

          <!--
                      <div class="divider my-3"></div>
                      <div class="d-flex align-items-center justify-content-between">
                          <div>
                              <div class="text-black-50" style="font-size: 0.8rem;">Currency</div>
                              <span style="font-weight: 500;">{{paymentTransData[0].CURRENCY_FLAG}}</span>
                          </div>
                      </div> -->
        </div>
      </div>
    </div>
    <div class="col-xl-4 p-4">
      <div class="divider-v divider-v-lg"></div>
      <div class="row">
        <div class="col">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <div class="text-black-50" style="font-size: 0.8rem;">Res Creation Date</div>
              <span style="font-weight: 500;">{{getDateFormat(paymentTransData[0]?.RESCREATIONDT)}}</span>
            </div>
          </div>
          <div class="divider my-3"></div>
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <div class="text-black-50" style="font-size: 0.8rem;">Res Start Date</div>
              <span style="font-weight: 500;">{{getTimeFormat(paymentTransData[0]?.STARTDT)}}</span>
            </div>
          </div>

          <!-- <div class="divider my-3"></div>
                      <div class="d-flex align-items-center justify-content-between">
                          <div>
                              <div class="text-black-50" style="font-size: 0.8rem;">Company Name</div>
                              <span style="font-weight: 500;">{{paymentTransData[0].COMPANY_NAME }}</span>
                          </div>
                      </div> -->
        </div>
      </div>
    </div>
    <div class="col-xl-4 p-4">
      <div class="divider-v divider-v-lg"></div>
      <div class="row">
        <div class="col">
          <div class="d-flex align-items-center justify-content-between"
            *ngIf=" (paymentTransData[0]?.TXREFNUM || paymentTransData[0]?.TXREFNUM == null)">
            <div>
              <div class="text-black-50" style="font-size: 0.8rem;">Customer Bill To (Company Name)</div>
              <span style="font-weight: 500;">{{paymentTransData[0]?.COMPANY_NAME }}</span>
            </div>
          </div>
          <!-- <div class="d-flex align-items-center justify-content-between">
                          <div>
                              <div class="text-black-50" style="font-size: 0.8rem;">Sub Total</div>
                              <span style="font-weight: 500;">{{paymentTransData[0].TRANSACTION_SUBTOTAL}}</span>
                          </div>
                      </div> -->
          <div class="divider my-3"></div>
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <div class="text-black-50" style="font-size: 0.8rem;">Currency</div>
              <span style="font-weight: 500;">{{paymentTransData[0]?.CURRENCY_FLAG}}</span>
            </div>
          </div>
          <!-- <div class="d-flex align-items-center justify-content-between">
                          <div>
                              <div class="text-black-50" style="font-size: 0.8rem;">Taxes</div>
                              <span style="font-weight: 500;">{{paymentTransData[0].TRANSACTION_TAXES }}</span>
                          </div>
                      </div> -->
          <!-- <div class="divider my-3"></div>
                      <div class="d-flex align-items-center justify-content-between">
                          <div>
                              <div class="text-black-50" style="font-size: 0.8rem;">Total Due</div>
                              <span style="font-weight: 500;">{{paymentTransData[0].TRANSACTION_TOTAL }}</span>
                          </div>
                      </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card card-box mb-2">
  <div class="card-body">
    <form [formGroup]="transactionChangeForm">
      <div class="row no-gutters " style="padding: 10px 20px;">
        <div class="col-md-2 col-sm-4  mr-4">
          <div class="form-group">
            <label for="exampleEmail">Sub Total </label>
            <input class="form-control" id="subTotal" name="subTotal" formControlName="subTotal" readOnly type="text">
            <!-- (ngModelChange)="amountChangeCheckingFn(f.subTotal.value)" -->
          </div>
        </div>
        <div class="col-md-2 col-sm-4  mr-4 ">
          <div class="form-group">

            <label for="exampleEmail">Tax </label>
            <input class="form-control" id="taxes" readOnly name="taxes" formControlName="taxes" type="text">

          </div>
        </div>
        <div class="col-md-2 col-sm-4 mr-4">
          <div class="form-group">
            <label for="exampleEmail">Total Amount </label>
            <input class="form-control" id="totalAmount" readOnly name="totalAmount" formControlName="totalAmount"
              type="text">
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div>
  <div class="card card-box mb-2" *ngIf="paymentTransData[0]?.FINAL_AMOUNT - paymentTransData[0]?.BLOCKED_AMOUNT > 0 
&& (paymentTransData[0]?.PAYMENT_STATUS != 'PP') && paymentTransData[0]?.PAYMENT_STATUS != 'P' ">
    <div class="card-body">
      <h5 class="font-size-xl font-weight-bold">Credit Card Payment for Additional Amount</h5>
      <p class="text-black-50 mb-4">You have an additional amount of
        <b>{{ paymentTransData[0]?.FINAL_AMOUNT - paymentTransData[0]?.BLOCKED_AMOUNT | currency }}</b>
        to pay via credit card.
      </p>
      <div class="p-4" *ngIf="transactionType == 'Credit Card' ">
        <form [formGroup]="creditCardForm">
          <h5 class="font-size-xl font-weight-bold">Credit Card Payment </h5>
          <p class="text-black-50 mb-4"> Add Credit Card details and submit the Transaction</p>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-5">
                <label for="152">Name on the Card * :</label>
                <div class="input-group">
                  <span class="input-group-prepend">
                    <span class="input-group-text">
                      <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                    </span>
                  </span>
                  <input formControlName="name" class="form-control" id="152" name="name" type="text"
                    [ngClass]="{'is-invalid': submitted && formControls.name.errors}" />
                </div>
                <div *ngFor="let validation of validation_messages.name">
                  <div class="error-message"
                    *ngIf="formControls.name.hasError(validation.type) && ((formControls.name.dirty  || formControls.name.touched))">
                    {{validation.message }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-5">
                <label for="52">Credit Card Number * :</label>
                <div class="input-group">
                  <span class="input-group-prepend">
                    <span class="input-group-text">
                      <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                    </span>
                  </span>
                  <input autocomplete="cc-number" ccNumber formControlName="creditCardNo" class="form-control"
                    name="cc-number" type="tel" id="cc-number"
                    [ngClass]="{'is-invalid': submitted && formControls.creditCardNo.errors}" />
                  <!-- [textMask]="{mask: maskCreditCard}" -->
                </div>
                <div *ngFor="let validation of validation_messages.creditCardNo">
                  <div class="error-message"
                    *ngIf="formControls.creditCardNo.hasError(validation.type) && ((formControls.creditCardNo.dirty  || formControls.creditCardNo.touched))">
                    {{validation.message }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-5">
                <label for="4">Expire Date * :</label>
                <div class="input-group">
                  <span class="input-group-prepend">
                    <span class="input-group-text">
                      <fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
                    </span>
                  </span>
                  <input formControlName="expireMonthYear" [textMask]="{mask: maskDate}" class="form-control" id="4"
                    name="date-mask" type="text"
                    [ngClass]="{'is-invalid': submitted && formControls.expireMonthYear.errors}" />
                </div>
                <div *ngFor="let validation of validation_messages.expireMonthYear">
                  <div class="error-message"
                    *ngIf="formControls.expireMonthYear.hasError(validation.type) && ((formControls.expireMonthYear.dirty  || formControls.expireMonthYear.touched))">
                    {{validation.message }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-5">
                <label for="4">CVV * :</label>
                <div class="input-group">
                  <span class="input-group-prepend">
                    <span class="input-group-text">
                      <fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
                    </span>
                  </span>
                  <input formControlName="cvv" [textMask]="{mask: maskUSPhone}" class="form-control" id="4"
                    name="date-mask" type="text" [ngClass]="{'is-invalid': submitted && formControls.cvv.errors}" />
                </div>
                <div *ngFor="let validation of validation_messages.cvv">
                  <div class="error-message"
                    *ngIf="formControls.cvv.hasError(validation.type) && ((formControls.cvv.dirty  || formControls.cvv.touched))">
                    {{validation.message }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 py-3">
              <button id="saveContractBtn" class="btn m-2 btn-primary btn-square" type="button"
                (click)="submitTransactionOfPayment(creditCardForm.value)">Submit</button>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>


  <div class="card card-box mb-2" *ngIf="(paymentTransData[0]?.FINAL_AMOUNT - paymentTransData[0]?.BLOCKED_AMOUNT > 0 
    && paymentTransData[0]?.PAYMENT_STATUS == 'PP')">

    <div class="card-body">
      <h5 class="font-size-xl font-weight-bold">
        {{ (paymentTransData[0]?.FINAL_AMOUNT - paymentTransData[0]?.BLOCKED_AMOUNT > 0)
        ? 'Additional amount has been successfully paid by credit card'
        : 'No additional amount required' }}
      </h5>

      <!-- For credit card payment success case -->
      <p class="text-black-50 mb-4"
        *ngIf="paymentTransData[0]?.PAYMENT_STATUS == 'PP' && paymentTransData[0]?.FINAL_AMOUNT - paymentTransData[0]?.BLOCKED_AMOUNT > 0">
        Captured the held amount from the credit card:
        <b>{{ paymentTransData[0]?.CHEQUE_NUMBER }}</b>. The additional amount was
        <b>{{ paymentTransData[0]?.FINAL_AMOUNT - paymentTransData[0]?.BLOCKED_AMOUNT | currency }}</b>.
      </p>
    </div>
  </div>

  <div class="card card-box mb-2"
    *ngIf="(paymentTransData[0]?.FINAL_AMOUNT - paymentTransData[0]?.BLOCKED_AMOUNT > 0 
  && (paymentTransData[0]?.PAYMENT_STATUS == 'PP') || paymentTransData[0]?.FINAL_AMOUNT - paymentTransData[0]?.BLOCKED_AMOUNT <= 0)">

    <div class="card-body">
      <h5 class="font-size-xl font-weight-bold">Mark & Capture Held Amount</h5>

      <!-- Display transaction reference number if available -->
      <p class="text-black-50 mb-4" *ngIf="paymentTransData[0]?.TXREFNUM">
        Capturing the held amount from the transaction reference number:
        <b>{{ paymentTransData[0]?.TXREFNUM }}</b>.
      </p>

      <!-- Display capture amount -->
      <p class="text-black-50 mb-4">
        Amount to be captured:
        <b>{{ paymentTransData[0]?.BLOCKED_AMOUNT | currency }}</b>
      </p>

      <div class="divider my-3"></div>

      <!-- Mark & Capture Button -->
      <button class="btn btn-neutral-success btn-lg mt-1" (click)="captureCCardAmount(paymentTransData[0])"
        type="button">
        Mark & Capture
      </button>
    </div>
  </div>
</div>
<ngx-spinner [fullScreen]="false" size="large" type="ball-spin-clockwise"></ngx-spinner>
<notifier-container></notifier-container>